var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPause = function SvgIconPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M11.2 4.9a1.4 1.4 0 0 0-2.8 0v18.2a1.4 1.4 0 1 0 2.8 0zM19.6 4.9a1.4 1.4 0 1 0-2.8 0v18.2a1.4 1.4 0 1 0 2.8 0z"
  })));
};
export default SvgIconPause;